import {
  getToken,
  setToken,
  removeToken
} from '@/utils/auth'
import api from '@/api/auth'

const getDefaultState = () => {
  return {
    token: getToken(),
    catelog: [],
    user: {}
  }
}

const state = getDefaultState()

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    setToken(token)
  },
  SET_CATE: (state, obj) => {
    state.catelog = obj.children
  },
  SET_USER: (state, user) => {
    state.user = user
  }
}

const actions = {

  login({ commit }, userInfo) {
    const { userno, password } = userInfo
    return new Promise((resolve, reject) => {
      api.login({ account: userno.trim(), password: password }).then((res) => {
        if (res.code === 2000) {
          const { items } = res
          commit('SET_TOKEN', items)
          setToken(items)
        }
        resolve(res)
      }).catch((error) => {
        reject(error)
      })
    })
  },

  resetToken({ commit }) {
    return new Promise((resolve, reject) => {
      api.reset().then((res) => {
        if (res.code === 2000) {
          const { items } = res
          commit('SET_TOKEN', items)
          setToken(items)
        }
        resolve(res)
      }).catch((error) => {
        reject(error)
      })
    })
  },

  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      const token = getToken()
      if (token) {
        commit('SET_TOKEN', token)
        const UserBase64Str = state.token.split('.')[1] // 获取用户信息部分
        let commonContent = UserBase64Str.replace(/\s/g, '+')
        commonContent = Buffer.from(commonContent, 'base64').toString()
        const userinfoString = JSON.parse(commonContent).userInfo
        const userinfo = JSON.parse(userinfoString)
        commit('SET_USER', userinfo)
        resolve(userinfo)
      } else {
        resolve(null)
      }
    })
  },

  logout({ commit }) {
    return new Promise((resolve, reject) => {
      removeToken()
      commit('SET_TOKEN', '')
      commit('SET_USER', null)
      resolve()
    })
  },

  reqCatelog({ commit }) {
    return new Promise((resolve, reject) => {
      api.catelog({ catalogId: 955 }).then((res) => {
        if (res.code === 0) {
          const { items } = res
          commit('SET_CATE', items.dictionaryList)
        }
        resolve(res)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
